import {makeEnvironmentProviders} from '@angular/core';
import {ApiConfiguration as AuthServerApiConfiguration} from './auth-server/api-configuration';
import {ApiConfiguration as ConfigServerApiConfiguration} from './config-server/api-configuration';
import {ApiConfiguration as CoreApiConfiguration} from './core/api-configuration';
import {ApiConfiguration as SubjectRegisterApiConfiguration} from './subject-register/api-configuration';
import {
  AUTH_MICROSERVICE_ROOT,
  CONFIG_MICROSERVICE_ROOT,
  CORE_MICROSERVICE_ROOT,
  SUBJECT_REGISTER_MICROSERVICE_ROOT
} from '|ui-essl-core';


export function provideApiDraftConfigurations() {
  return makeEnvironmentProviders([
    {
      provide: AuthServerApiConfiguration,
      useValue: {rootUrl: AUTH_MICROSERVICE_ROOT},
    },
    {
      provide: ConfigServerApiConfiguration,
      useValue: {rootUrl: CONFIG_MICROSERVICE_ROOT},
    },
    {
      provide: CoreApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: SubjectRegisterApiConfiguration,
      useValue: {rootUrl: SUBJECT_REGISTER_MICROSERVICE_ROOT},
    },
  ]);
}
